var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7678 12.9295L16.0869 15.2475C16.1951 15.3595 16.2549 15.5094 16.2536 15.6651C16.2522 15.8208 16.1898 15.9697 16.0797 16.0798C15.9696 16.1899 15.8207 16.2523 15.665 16.2537C15.5093 16.255 15.3594 16.1952 15.2474 16.087L12.9282 13.7678C11.4127 15.0663 9.4531 15.7273 7.46072 15.6121C5.46834 15.497 3.598 14.6146 2.24218 13.1501C0.886351 11.6857 0.150431 9.75304 0.18884 7.7577C0.227248 5.76236 1.037 3.85945 2.44818 2.44827C3.85936 1.03709 5.76227 0.22734 7.75761 0.188931C9.75295 0.150522 11.6856 0.886442 13.1501 2.24227C14.6145 3.59809 15.4969 5.46843 15.612 7.46081C15.7272 9.4532 15.0662 11.4127 13.7678 12.9283V12.9295ZM7.90625 14.4376C9.63845 14.4376 11.2997 13.7495 12.5245 12.5246C13.7494 11.2998 14.4375 9.63854 14.4375 7.90635C14.4375 6.17415 13.7494 4.5129 12.5245 3.28806C11.2997 2.06321 9.63845 1.3751 7.90625 1.3751C6.17406 1.3751 4.51281 2.06321 3.28796 3.28806C2.06312 4.5129 1.375 6.17415 1.375 7.90635C1.375 9.63854 2.06312 11.2998 3.28796 12.5246C4.51281 13.7495 6.17406 14.4376 7.90625 14.4376Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3cb31fb643901748753a596af5325a68.svg";
export { ForwardRef as ReactComponent };